module.exports = __webpack_public_path__ + "img/q.29b461af.jpg";